export const MAX_ACH_IMPORT_FILE_SIZE_BYTES = 25 * 1024 * 1024; // 25 MB

export const NACHA_EXTENSIONS = [".nacha", ".txt"];
export const CSV_EXTENSIONS = [".csv"];
export const ALLOWED_EXTENSIONS = [
  ...NACHA_EXTENSIONS,
  ...CSV_EXTENSIONS,
];
